import { Checkbox } from 'root/src/client/v2/form/components/Checkbox';
export const CheckboxField = ({ options, label, className, value = [], onChange, }) => {
    const handleToggle = (val) => {
        var _a;
        const isChecked = value.includes(val);
        const updated = isChecked
            ? (_a = value.filter(v => v !== val)) !== null && _a !== void 0 ? _a : []
            : [...value, val];
        onChange(updated);
    };
    return (<ul className={`flex flex-col list-none gap-3${className ? ` ${className}` : ''}`}>
			{label && <span className="text-[15px] font-medium">{label}</span>}
			{options.map(({ label: optionLabel, value: optionValue }) => (<li key={String(optionValue)} className="select-none">
					<label htmlFor={`option-${optionValue}`} className="flex items-center gap-2 w-full cursor-pointer">
						<Checkbox id={`option-${optionValue}`} checked={value === null || value === void 0 ? void 0 : value.includes(optionValue)} onCheckedChange={() => {
                handleToggle(optionValue);
            }}/>
						<span className="text-[14px]">{optionLabel}</span>
					</label>
				</li>))}
		</ul>);
};
